import React, { useState } from "react";
import "./index.css";
import { Link, useLocation } from "react-router-dom";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import {
  AttachMoney,
  CardMembershipRounded,
  KeyboardArrowDown,
  KeyboardArrowRight,
  People,
  Rocket,
  ShoppingBag,
  ShoppingBasketSharp,
  VerifiedUserSharp,
  AutoMode,
  Web,
  Calculate,
  EventNote,
  Lightbulb,
  BadgeOutlined,
  TrendingUp,
} from "@mui/icons-material";
import { useAuth } from "context/auth/auth";
import logo from "../../assets/white.png";

const NAV_ITEMS = [
  // ─── ERP-Accounting (núcleo del producto) ───
  { label: "Portal Clientes", path: "/admin/portal-clientes", icon: Web },
  { label: "Contabilidad", path: "/admin/accounting", icon: Calculate },
  { label: "Tributario", path: "/admin/tributario", icon: EventNote },
  { label: "Remuneraciones", path: "/admin/remuneraciones", icon: BadgeOutlined },
  { label: "Recomendaciones", path: "/admin/recomendaciones", icon: Lightbulb },
  { label: "Indicadores", path: "/admin/indicadores", icon: TrendingUp },
  { label: "iContador", path: "/admin/icontador", icon: AutoMode },
  // ─── Módulos secundarios / legacy ───
  { label: "Turno", path: "/daily/gym", icon: AddBusinessIcon },
  { label: "Cajas", path: "/admin/daily/history", icon: AttachMoney },
  { label: "Clientes", path: "/admin/members", icon: People },
  { label: "Servicios", path: "/admin/products", icon: ShoppingBag },
  { label: "Areas de servicio", path: "/admin/warehouses", icon: ShoppingBasketSharp },
  { label: "Campanas", path: "/admin/marketing", icon: Rocket },
  { label: "Usuarios", path: "/admin/users", icon: VerifiedUserSharp },
  { label: "Planes", path: "/admin/memberships/settings", icon: CardMembershipRounded },
];

function NavItem({ label, path, Icon }) {
  const location = useLocation();
  const isActive = location.pathname === path;

  return (
    <Link to={path} style={{ textDecoration: "none" }}>
      <div className={`sidebar-item${isActive ? " active" : ""}`}>
        <Icon className="sidebar-icon" />
        <span>{label}</span>
      </div>
    </Link>
  );
}

export default function Sidebar() {
  const auth = useAuth();
  const location = useLocation();
  const [hubOpen, setHubOpen] = useState(true);
  const firstName = auth.user?.name?.split(" ")[0] || "";

  return (
    <nav className="sidebar-nav">
      {/* Logo */}
      <div style={{ padding: "20px 16px 12px", textAlign: "center" }}>
        <img src={logo} alt="Profit" style={{ width: 120, margin: "0 auto" }} />
      </div>

      <div className="sidebar-divider" />

      {/* Greeting */}
      <div style={{ padding: "10px 16px 6px", display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: "rgba(77,159,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 11,
            fontWeight: 700,
            color: "#4d9fff",
            flexShrink: 0,
          }}
        >
          {firstName.charAt(0).toUpperCase()}
        </div>
        <span style={{ fontSize: 12, color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>
          Hola, {firstName}
        </span>
      </div>

      <div className="sidebar-divider" />

      {/* Admin Hub section */}
      <div style={{ flex: 1, paddingTop: 6 }}>
        <div className="sidebar-section-header" onClick={() => setHubOpen(!hubOpen)}>
          <span>Admin Hub</span>
          {hubOpen ? (
            <KeyboardArrowDown style={{ fontSize: 16, opacity: 0.6 }} />
          ) : (
            <KeyboardArrowRight style={{ fontSize: 16, opacity: 0.6 }} />
          )}
        </div>

        <div className={`sidebar-collapse ${hubOpen ? "open" : "closed"}`}>
          {NAV_ITEMS.map((item) => (
            <NavItem key={item.path} label={item.label} path={item.path} Icon={item.icon} />
          ))}
        </div>

        <div className="sidebar-divider" style={{ marginTop: 12 }} />

        {/* Dashboard (admin only) */}
        {auth.isAdmin && (
          <NavItem label="Dashboard" path="/admin/dashboard" Icon={DashboardIcon} />
        )}
      </div>

      {/* Logout */}
      <div style={{ paddingBottom: 16 }}>
        <div className="sidebar-divider" />
        <div className="sidebar-logout" onClick={() => auth.revokeAuth({ isMember: false })}>
          <MeetingRoomIcon className="sidebar-icon" />
          <span>Cerrar Sesion</span>
        </div>
      </div>
    </nav>
  );
}
